import * as STD from '@emersya/mpa-std-lib';

import CM                                      from '@emersya/mpa-components-manager-lib';
import { Section }                             from '@emersya/mpa-components-lib';
import ViewerComponent                         from '../../../Viewer/Viewer';

export interface IPlannerFurnitureCategoryTileComponentConfiguration extends Section.Configuration {
	productsConfigurations : MPAEngineApplicationNS.Configuration['productsComponents'];
	categoryConfiguration : MPAEngineApplicationNS.Configuration['productsComponentsCategories'][''];
};

export class PlannerFurnitureCategoryTileComponent extends Section.Component<
	PlannerFurnitureCategoryTileComponent,
	IPlannerFurnitureCategoryTileComponentConfiguration
>
{
	readonly plannerCategory! : ViewerComponent.ProductCategory;

	get products() {
		return <PlannerFurnitureProductTileNS.Component[]> this.component_find('@:content').component_outerChilds;
	};

	async update() {
		const CP = app.currentProduct;
		if (!CP || !CP.reference) {
			this.component_throwLibraryError('');
		}
		let hasSomeEnabledFurniture = false;
		for (const furniture of this.products) {
			const PC = this.component_configuration.productsConfigurations.find(x => x.SKU === furniture.id);
			if (!PC) {
				this.component_throwLibraryError('');
			}
			if (PC.products.includes(CP.reference.value)) {
				if (furniture.component_activation.preventedByConfiguration) {
					await furniture.component_enable();
				}
				hasSomeEnabledFurniture = true;
			} else {
				if (!furniture.component_activation.preventedByConfiguration) {
					await furniture.component_disable();
				}
			}
		}
		if (hasSomeEnabledFurniture) {
			if (this.component_activation.preventedByConfiguration) {
				await this.component_enable();
			}
		} else {
			if (!this.component_activation.preventedByConfiguration) {
				await this.component_disable();
			}
		}
	};

	override async component_start(ev : STD.events.Event<any, any>) {
		if (!app.viewer.planner) {
			this.component_throwUserError('');
		}
		(<any> this).plannerCategory = app.viewer.createCategory({
			name :        this.id,
			menuActions : {
				edit :      true,
				delete :    true,
				rotate :    true,
				duplicate : false
			},
			products :    []
		});
		const content = this.component_find('@:content');
		for (const productConfiguration of this.component_configuration.productsConfigurations) {
			const furniture = await content.component_instantiateOuterChild<PlannerFurnitureProductTileNS.Configuration>(
				{
					type :          'viewer-planner-furniture-productTile',
					id :            productConfiguration.SKU,
					tree :          this.component_tree,
					slot :          null,
					isSlot :        false,
					declaredSlot :  null,
					configuration : {
						productConfiguration
					}
				}
			);
			await furniture.component_initialize();
			await furniture.component_start(ev);
		}
		await super.component_start(ev);
		STD.translationsManager.update(this.component_DOM);
	};

	constructor(
		descriptor : ConstructorParameters<typeof CM.Component>[0],
		configuration : IPlannerFurnitureCategoryTileComponentConfiguration
	)
	{
		STD.object.deepMergeAssign(configuration, [
			{
				'@innerConfigurations' : {
					header : {
						'@innerConfigurations' : {
							blockTitle : {
								'@innerConfigurations' : {
									title : {
										'@translations' : {
											text : configuration.categoryConfiguration.translations[ '@name' ]
										}
									}
								}
							}
						}
					}
				}
			}
		]);
		super(descriptor, configuration);
	};
};
export namespace NS {
	export const Component = PlannerFurnitureCategoryTileComponent;
	export type Component = PlannerFurnitureCategoryTileComponent;
	export type Configuration = IPlannerFurnitureCategoryTileComponentConfiguration;
}
import manifestXMLSource                       from './PlannerFurnitureCategoryTile.xml';
import './PlannerFurnitureCategoryTile.scss';
import { NS as MPAEngineApplicationNS }        from '../../../../mpa-engine/Application/MPAEngineApplication';
import { NS as PlannerFurnitureProductTileNS } from '../ProductTile/PlannerFurnitureProductTile';

CM.declare({
	id :       'viewer-planner-furniture-categoryTile',
	type :     PlannerFurnitureCategoryTileComponent,
	manifest : manifestXMLSource
});
